import { getMessage } from "common/messageUtil"
import { magiContants } from "utils/contants"

const initialValues = {
  selectionFileManagementId: [0],
  selectionFileName: '',
  targetYear: '',
  targetYearList: [],
  companyId: 0,
}

export interface InitialValues {
  selectionFileManagementId: number[]
  selectionFileName: string
  targetYear: string
  targetYearList: string[]
}

const initRequest = {
  selectionFileManagementId: 0,
  versionNumber: 0,
  companyId: '',
  yearDeterminingMediaFlag: ''
}

const initResponse= {
    companyId: '',
    selectionFileName: '',
    targetYearList: [],
    yearDeterminingMediaFlag: '',
}

const textMap = {
  create: {
    submit: 'OK',
    cancel: 'キャンセル',
    message: getMessage(magiContants.MESSAGECODE_MCBOS020_005),
  },
  cancel: {
    submit: 'OK',
    cancel: 'キャンセル',
    message: getMessage(magiContants.MESSAGECODE_MCBOS020_006),
  },
}
export {
  textMap,
  initialValues,
  initRequest,
  initResponse
}
